import type { ContentObject } from 'models';
import { useTranslation } from 'react-i18next';
import { usePermissions } from 'permissions';
import { Button, Dropdown, Icon, message } from 'ui';
import type { Network } from 'common/utils';
import { copyLinkToClipboard } from 'features/copy-to-clipboard';
import { useOnShareSocial } from './hooks';

type P = {
  item: ContentObject;
};

const ShareButton = ({ item }: P) => {
  const onShareSocial = useOnShareSocial();
  const { t } = useTranslation();
  const { canShareContentObject } = usePermissions();

  const canShare = canShareContentObject({ contentObject: item });

  const generateItems = () => {
    const actions = [
      {
        icon: <Icon height={16} icon="link-line" width={16} />, // TODO some size prop should handle icon size
        key: 'link',
        label: t('Copy link'),
      },
    ];

    if (canShare) {
      actions.push(
        {
          icon: <Icon height={16} icon="mail-send-line" width={16} />, // TODO some size prop should handle icon size
          key: 'email',
          label: t('Share via email'),
        },
        {
          icon: <Icon height={16} icon="linkedin" width={16} />, // TODO some size prop should handle icon size
          key: 'linkedin',
          label: t('Share on LinkedIn'),
        },
        {
          icon: <Icon height={16} icon="fb" width={16} />, // TODO some size prop should handle icon size
          key: 'facebook',
          label: t('Share on Facebook'),
        },
      );
    }

    return actions;
  };

  const copyLink = async () => {
    try {
      await copyLinkToClipboard(item);
      message.success('Link copied to clipboard');
    } catch {
      message.error('Sorry, something went wrong.');
    }
  };

  const onClick = ({ key }: { key: string }): Promise<void> | void => {
    if (key === 'link') {
      return copyLink();
    }

    if (item.type === 'event') {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- key comes from menu items built from a fixed set of Network values
    onShareSocial(key as Network, item);
  };

  return (
    <div className="share-button">
      <Dropdown
        menu={{
          items: generateItems(),
          onClick,
        }}
        trigger={['click']}
      >
        <Button icon={<Icon icon="share-forward-line" />} type="text">
          Share
        </Button>
      </Dropdown>
    </div>
  );
};

export default ShareButton;
